<app-navbar></app-navbar>

<!-- Page Banner -->
<div class="rs-page-banner">
  <div class="rs-pb-deco">
    <div class="rs-pb-dots"></div>
    <div class="rs-pb-circle rs-pb-c1"></div>
    <div class="rs-pb-circle rs-pb-c2"></div>
  </div>
  <div class="container">
    <div class="rs-pb-content">
      <h1 class="rs-pb-title">Administration</h1>
      <nav class="rs-pb-breadcrumb">
        <a routerLink="/">Home</a>
        <i class="ri-arrow-right-s-line"></i>
        <span>Administration</span>
      </nav>
    </div>
  </div>
</div>

<div class="rs-inner-page">
<div class="container" style="padding: 0;">
  <div
    class="card mt-3 mb-3"
    style="background: transparent; border: none"
    *ngIf="!fetchinData"
  >  
    <div class="card-body">
      <div class="row">
       
        <div class="col-md-12" style="padding: 1;">
          <div style="min-height: 800px">
            <div>
              <div
                class="container"
                *ngIf="selectedItem && selectedItem === 'governing-body'"
              >
              <div
                          class="box-title text-cen sidebar-primary"
                          style="font-family: 'Ubuntu' !important"
                        >
                          <p style="margin-bottom: 10px; width: 1108px; margin-left: -11px;" class="widget-title">
                            Governing Body
                          </p>
                        </div>
                <ng-container *ngIf="GBs == null" class="spinner-overlay">
                  <span class="fetching-data-text">No Data Found</span>
                </ng-container>

                <div class="row justify-content-center" *ngIf="GBs != null">
                  <ng-container *ngIf="GBs1 != null">
                 
                  </ng-container>
                </div>

                <div class="row justify-content-center" *ngIf="GBs2 != null">
                

                  <div class="container">
                    <ng-container *ngIf="GBs1 != null">
                      <div class="row pdf-holder">
                        <div
                          class="col-md-2 col-sm-2"
                          style="
                            border-right: 1px solid rgba(0, 0, 0, 0.35);
                            border-right: 1px solid rgba(0, 0, 0, 0.35);
                            display: flex;
                            align-items: center;
                            justify-content: center;
                          "
                        >
                          <h3>
                            <small>1</small>
                          </h3>
                        </div>
                        <div
                          class="col-md-7 col-sm-7"
                          style="border-right: 1px solid rgba(0, 0, 0, 0.35)"
                        >
                          <span
                            style="
                              font-size: 24px;  
                              line-height: 2;
                            "
                            >{{ GBs1.Name }}</span
                          ><br />
                          <span
                            style="
                              font-size: 18px;                             
                              line-height: 2;
                            "
                            >{{ GBs1.Rank }}</span
                          ><br />
                          <span
                            style="
                              font-size: 18px;                             
                              line-height: 2;
                            "
                            >{{ GBs1.GBDesignation }}</span
                          >
                        </div>
                        <div class="col-md-3 col-sm-3 text-center">
                          <img
                            [src]="GBs1.ImagePath"
                            class="img-responsive"
                            style="
                              height: 150px;
                              width: auto;
                              object-fit: cover;
                            "
                          />
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngFor="let data of GBs2; let i = index">
                      <div class="row pdf-holder">
                        <div
                          class="col-md-2 col-sm-2"
                          style="
                            border-right: 1px solid rgba(0, 0, 0, 0.35);
                            border-right: 1px solid rgba(0, 0, 0, 0.35);
                            display: flex;
                            align-items: center;
                            justify-content: center;
                          "
                        >
                          <h3>
                            <small>{{ i + 2 }}</small>
                          </h3>
                        </div>
                        <div
                          class="col-md-7 col-sm-7"
                          style="border-right: 1px solid rgba(0, 0, 0, 0.35)"
                        >
                          <span
                            style="
                              font-size: 24px;                        
                              line-height: 2;
                            "
                            >{{ data.Name }}</span
                          ><br />
                          <span
                            style="
                              font-size: 18px;                           
                              line-height: 2;
                            "
                            >{{ data.Rank }}</span
                          ><br />
                          <span
                            style="
                              font-size: 18px;                        
                              line-height: 2;
                            "
                            >{{ data.GBDesignation }}</span
                          >
                        </div>
                        <div class="col-md-3 col-sm-3 text-center">
                          <img
                            [src]="data.ImagePath"
                            class="img-responsive"
                            style="
                              height: 150px;
                              width: auto;
                              object-fit: cover;
                            "
                          />
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
              <div
                class="container"
                *ngIf="selectedItem && selectedItem === 'ex-principals'"
              >
                <ng-container
                  *ngIf="GBExPrincipal == null"
                  class="spinner-overlay"
                >
                  <span class="fetching-data-text">No Data Found</span>
                </ng-container>
                <div class="row justify-content-center" *ngIf="GBExPrincipal != null">
                  <div class="col-md-12" style="padding: 0;">
                    <div
                      class="box-title text-center sidebar-primary"
                      style="font-family: 'Ubuntu' !important"
                    >
                      <p
                        style="margin-bottom: 10px; width: 1108px; "
                        class="widget-title"
                      >
                        Former Principals of the School
                      </p>
                    </div>
              
                    <!-- Table Design -->
                    <div class="table-container" style="padding: 0;">
                      <table class="ex-chairman-table">
                        <thead>
                          <tr>
                            <th>S/N</th>
                            <th style="text-align: start;">Name of the Ex-Principal</th>
                            <th colspan="2">Working Period</th>
                            <th>Photo</th>
                          </tr>
                          <tr>
                            <th></th>
                            <th></th>
                            <th>From</th>
                            <th>To</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let data of GBExPrincipal; let i = index">
                            <td>{{ i + 1 }}</td>
                            <td style="text-align: start;">{{ data.Name }}</td>
                            <td>{{ data.StartDate | date:'dd-MM-yyyy' }}</td>
                            <td>{{ data.Address || (data.StartDate | date:'dd-MM-yyyy') }}</td>
                            
                            <td>
                              <img
                                [src]="data.ImagePath"
                                alt="Chairman Photo"
                                style="height: 100px; width: auto; object-fit: cover"
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <!-- End Table Design -->
                  </div>
                </div>
              </div>
              <div
                class="container"
                *ngIf="selectedItem && selectedItem === 'vice-chairman'"
              >
               
                <div class="row justify-content-center" *ngIf="GBViceChairman != null">
                  <div class="col-md-12" style="padding: 0;">
                    <div
                      class="box-title text-center sidebar-primary"
                      style="font-family: 'Ubuntu' !important"
                    >
                      <p
                        style="margin-bottom: 10px; width: 1108px; "
                        class="widget-title"
                      >
                       Vice Chairman of the School
                      </p>
                    </div>
              
                    <!-- Table Design -->
                    <div class="table-container" style="padding: 0;">
                      <table class="vice-chairman-table">
                        <thead>
                          <tr>
                            <th>S/N</th>
                            <th style="text-align: start;">Name of the Vice-Chairman</th>
                            <th colspan="2">Working Period</th>
                            <th>Photo</th>
                          </tr>
                          <tr>
                            <th></th>
                            <th></th>
                            <th>From</th>
                            <th>To</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let data of GBViceChairman; let i = index">
                            <td>{{ i + 1 }}</td>
                            <td style="text-align: start;">{{ data.Name }}</td>
                            <td>{{ data.StartDate | date:'dd-MM-yyyy' }}</td>
                            <td>{{ data.Address || (data.StartDate | date:'dd-MM-yyyy') }}</td>
                            
                            <td>
                              <img
                                [src]="data.ImagePath"
                                alt="Chairman Photo"
                                style="height: 100px; width: auto; object-fit: cover"
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <!-- End Table Design -->
                  </div>
                </div>
              </div>
              <div
                class="container"
                *ngIf="selectedItem && selectedItem === 'teacher-information'"
              >
                <ng-container
                  *ngIf="paginated_teachers_info == null"
                  class="spinner-overlay"
                >
                  <span class="fetching-data-text">No Data Found</span>
                </ng-container>

                <!-- <div
                  class="row justify-content-center"
                  *ngIf="TeacherInfo != null"
                >
                  <ng-container *ngFor="let item of TeacherInfo">
                    <div
                      class="col-sm-3 single-courses-box"
                      style="margin: 10px 0px"
                    >
                      <div class="single-courses">
                        <div class="courses-img" style="height: 300px">
                          <img
                            [src]="item.ImageLink"
                            class="img-responsive"
                            style="height: 100%; width: 100%; object-fit: cover"
                          />
                        </div>
                        <div class="courses-price" style="background-color: #fff;">
                          <ul class="list-unstyled">
                            <li class="courses-teacher">
                              <span
                                ><img
                                  src="../../../../assets/img/ACPS_LOGO.png"
                                  width="45"
                                  height="45"
                                  alt=""
                                  class="img-circle"
                              /></span>
                            </li>
                            <li class="price-red">
                              <span style="font-size: 12px;">{{ item.Designation }}</span>
                              <div class="base"></div>
                            </li>
                          </ul>
                        </div>
                        <div class="courses-content" style="background-color: #fff;">
                          <span style="font-size: 1.2; font-weight: bolder">{{
                            item.EmployeeName
                          }}</span
                          ><br />
                          <span style="font-size: 1.2; font-weight: bolder">{{
                            item.Rank
                          }}</span
                          ><br />
                          <span style="font-size: 1.1em; font-weight: bolder">{{
                            item.Designation
                          }}</span>
                          <p>Adamjee Cantonment Public School</p>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div> -->
                <section class="" style="font-family: 'Ubuntu' !important">
                  <div class="container" style="background: transparent; padding: 0;">
                    <div class="row">
                      <div class="col-lg-12 col-md-12" style="padding: 0;">
                        <div
                          class="box-title text-cen sidebar-primary"
                          style="font-family: 'Ubuntu' !important"
                        >
                          <p style="margin-bottom: 10px" class="widget-title">
                            Teacher's Infotmation
                          </p>
                        </div>
                        <ng-container>
                          <!-- Dynamic Ok -->
                          <div class="bg-image">
                            <div
                              class="container"
                              style="padding-top: 10px; padding-bottom: 20px"
                            >
                              <div class="row">
                                <div class="col-md-12" style="padding: 0px">
                                  <div style="min-height: 800px">
                                    <div
                                      *ngFor="
                                        let item of paginated_teachers_info;
                                        let i = index
                                      "
                                      class="blog-details-desc"
                                      style="
                                        padding: 20px;
                                        border: 1px solid #eeeeee;
                                        margin: 15px 0px;
                                        box-shadow: 2px 4px 13px 1px grey;
                                        background: #fff;
                                      "
                                    >
                                      <div class="container">
                                        <div class="row align-items-center">
                                          <div class="col-lg-1">
                                            <h4>
                                              {{ pageIndex * pageSize + i + 1 }}
                                            </h4>
                                          </div>
                                          <div class="col-lg-8 col-md-12" style="line-height: 0;">
                                            <div>
                                              <h3 class="elip">
                                                {{ item.EmployeeName }}
                                              </h3>
                                              <p class="elip">
                                                Designation:
                                                {{ item.Designation }}
                                              </p>
                                              <p class="elip">
                                                EmployeeId:
                                                {{ item.EmployeeId }}
                                              </p>
                                              <p class="elip">
                                                JoiningDate:
                                                {{
                                                  item.JoiningDate
                                                    | date : "yyyy-MM-dd"
                                                }}
                                              </p>
                                            </div>
                                          </div>
                                          <div
                                            class="col-lg-2 col-md-3 col-sm-12"
                                          >
                                            <div class="about-image" style="border: 2px solid #dbbdbd;">
                                              <img
                                                [src]="item.ImageLink"
                                                alt="image"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="pagination">
                                      <button
                                        (click)="onPageChange(pageIndex - 1)"
                                        [disabled]="pageIndex === 0"
                                      >
                                        Previous
                                      </button>

                                      <button
                                        *ngFor="
                                          let page of totalPages;
                                          let i = index
                                        "
                                        (click)="onPageChange(i)"
                                        [class.active]="pageIndex === i"
                                      >
                                        {{ page }}
                                      </button>

                                      <button
                                        (click)="onPageChange(pageIndex + 1)"
                                        [disabled]="
                                          pageIndex + 1 >= totalPages.length
                                        "
                                      >
                                        Next
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- Dynamic Ends -->
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div
                class="container" style="padding: 0;"
                *ngIf="selectedItem && selectedItem === 'staff-information'"
              >
                <ng-container
                  *ngIf="paginated_staff_info == null"
                  class="spinner-overlay"
                >
                  <span class="fetching-data-text">No Data Found</span>
                </ng-container>

                <div
                  class="row justify-content-center"
                  *ngIf="paginated_staff_info != null"
                >
                  <section class="" style="font-family: 'Ubuntu' !important">
                    <div class="container" style="background: transparent">
                      <div class="row">
                        <div class="col-lg-12 col-md-12" style="padding: 0;">
                          <div
                            class="box-title text-cen sidebar-primary"
                            style="font-family: 'Ubuntu' !important"
                          >
                            <p style="margin-bottom: 10px" class="widget-title">
                              Staff Infotmation
                            </p>
                          </div>
                          <ng-container>
                            <!-- Dynamic Ok -->
                            <div class="bg-image">
                              <div
                                class="container"
                                style="padding-top: 10px; padding-bottom: 20px"
                              >
                                <div class="row">
                                  <div class="col-md-12" style="padding: 0px">
                                    <div style="min-height: 800px">
                                      <div
                                        *ngFor="
                                          let item of paginated_staff_info;
                                          let i = index
                                        "
                                        class="blog-details-desc"
                                        style="
                                          padding: 20px;
                                          border: 1px solid #eeeeee;
                                          margin: 15px 0px;
                                          box-shadow: 2px 4px 13px 1px grey;
                                          background: #fff;
                                        "
                                      >
                                        <div class="container">
                                          <div class="row align-items-center">
                                            <div class="col-lg-1">
                                              <h4>
                                                {{
                                                  pageIndex * pageSize + i + 1
                                                }}
                                              </h4>
                                            </div>
                                            <div class="col-lg-8 col-md-12">
                                              <div>
                                                <h3 class="elip">
                                                  {{ item.EmployeeName }}
                                                </h3>
                                                <p class="elip">
                                                  Designation:
                                                  {{ item.Designation }}
                                                </p>
                                                <p class="elip">
                                                  EmployeeId:
                                                  {{ item.EmployeeId }}
                                                </p>
                                                <p class="elip">
                                                  JoiningDate:
                                                  {{
                                                    item.JoiningDate
                                                      | date : "yyyy-MM-dd"
                                                  }}
                                                </p>
                                              </div>
                                            </div>
                                            <div
                                              class="col-lg-2 col-md-3 col-sm-12"
                                            >
                                              <div class="about-image" style="border: 2px solid #dbbdbd;">
                                                <img
                                                  [src]="item.ImageLink"
                                                  alt="image"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div class="pagination">
                                        <button
                                          (click)="
                                            onPageChange_staff(pageIndex - 1)
                                          "
                                          [disabled]="pageIndex === 0"
                                        >
                                          Previous
                                        </button>

                                        <button
                                          *ngFor="
                                            let page of totalPages;
                                            let i = index
                                          "
                                          (click)="onPageChange_staff(i)"
                                          [class.active]="pageIndex === i"
                                        >
                                          {{ page }}
                                        </button>

                                        <button
                                          (click)="
                                            onPageChange_staff(pageIndex + 1)
                                          "
                                          [disabled]="
                                            pageIndex + 1 >= totalPages.length
                                          "
                                        >
                                          Next
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- Dynamic Ends -->
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
           
              <div
                class="container"
                *ngIf="
                  selectedItem &&
                  selectedItem !== 'governing-body' &&
                  selectedItem !== 'teacher-information' &&
                  selectedItem !== 'staff-information' &&
                  selectedItem !== 'ex-principals' &&
                  selectedItem !== 'ex-chairman'
                "
              >
                <!-- <ng-container *ngIf="GBms == null" class="spinner-overlay">
                  <span class="fetching-data-text">No Data Found</span>
                </ng-container> -->
                <ng-container *ngIf="GBms1 != null">
                  <div class="row justify-content-center">
                    <div class="col-md-8 text-justify" style="padding: 0;">
                      <div>
                        <div
                          class="box-title text-cen sidebar-primary"
                          style="font-family: 'Ubuntu' !important"
                        >
                          <p style="margin-bottom: 10px" class="widget-title">
                            {{ GBms1.GBDesignationName }}'s Message
                          </p>
                        </div>
                        <img
                          alt="Message"
                          class="img-thumbnail img-fluid"
                          [src]="GBms1.GBImagePath"
                          style="
                            display: block;
                            margin: 0 auto;
                            height: 300px;
                            width: auto;
                          "
                        />
                      </div>
                      <div style="background-color: #fff !important; padding: 15px; border-radius: 8px;">
                        <p style="text-align: justify; margin: 0;" [innerHTML]="GBms1.DetailsEn"></p>
                      </div>
                      
                    </div>
                    <div class="col-md-4" style="background-color: transparent">
                      <app-gb-aside></app-gb-aside>
                    </div>
                  </div>
                </ng-container>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <!-- </div> -->
    <div aria-hidden="true" *ngIf="fetchinData" class="col-lg-12 col-md-12">
      <h5 class="placeholder-glow">
        <span class="placeholder col-12" style="height: 200px"></span>
      </h5>
    </div>
  </div>
</div>
</div><!-- /.rs-inner-page -->
